import { useEffect } from 'react'
import { useUser, useAuth } from '@clerk/clerk-react'
import { useAuthStore } from '@/store/authStore'
import { useUserPreferences } from './useUserPreferences'

/**
 * Hook to sync Clerk authentication state with Zustand auth store
 * Also loads user preferences (branch selection) from backend
 * Call this hook in the root App component or a layout component
 */
export function useAuthSync() {
  const { user, isLoaded: userLoaded } = useUser()
  const { isSignedIn, isLoaded: authLoaded } = useAuth()
  const setAuthState = useAuthStore((state) => state.setAuthState)
  const setSelectedBranchId = useAuthStore((state) => state.setSelectedBranchId)
  const setSelectedRestaurantId = useAuthStore((state) => state.setSelectedRestaurantId)

  // Fetch user preferences (branch selection)
  const { data: preferences, isLoading: prefsLoading } = useUserPreferences()

  // Sync Clerk auth state
  useEffect(() => {
    if (userLoaded && authLoaded) {
      setAuthState(isSignedIn ?? false, user, false)
    } else {
      setAuthState(false, null, true)
    }
  }, [user, isSignedIn, userLoaded, authLoaded, setAuthState])

  // Sync user preferences to auth store once preferences are loaded
  useEffect(() => {
    if (!prefsLoading && preferences && isSignedIn) {
      if (preferences.lastBranchId) {
        setSelectedBranchId(preferences.lastBranchId)
      }
      if (preferences.lastRestaurantId) {
        setSelectedRestaurantId?.(preferences.lastRestaurantId)
      }
    }
  }, [preferences, prefsLoading, isSignedIn, setSelectedBranchId, setSelectedRestaurantId])
}

